import { databaseNamespaceOptions, IOptionType } from "../../types/common";

interface configState {
    top_k: number;
    top_productCategories: number;
    metadataSelector: boolean;
    showProductCategories: boolean;
    showDistance: boolean;
    showDeepSearchHint: boolean;
    databaseNamespaces: IOptionType;
}
export const ConfigState: configState = {
    top_k: 100,
    top_productCategories: 5,
    metadataSelector: false,
    showProductCategories: true,
    showDistance: true,
    showDeepSearchHint: false,
    databaseNamespaces: databaseNamespaceOptions[0]
}

const getLocalItem = (item: string, default_value: any = '', json_parsing: boolean = false) => {
    let item_value = window.localStorage.getItem(item)
    if (item_value) {
        if (json_parsing) {
            return JSON.parse(item_value)
        }
        return item_value
    } else {
        return default_value
    }
}
const setLocalItem = (item: string, value: any = '') => {
    window.localStorage.setItem(item, value);
}

export const createConfigSlice = (set: any, get: any) => ({
    ...createConfigStates(set),
    ...createConfigActions(set, get),
});

const createConfigStates = (set: any) => ({
    top_k: getLocalItem('top_k', ConfigState.top_k) as number,
    setTop_k: (top_k: number) =>
        set((state: any) => {
            setLocalItem('top_k', top_k)
            state.top_k = top_k;
        }),
    top_productCategories: getLocalItem('top_productCategories', ConfigState.top_productCategories) as number,
    setTop_productCategories: (top_productCategories: number) =>
        set((state: any) => {
            setLocalItem('top_productCategories', top_productCategories)
            state.top_productCategories = top_productCategories;
        }),
    metadataSelector: (getLocalItem('metadataSelector', ConfigState.metadataSelector) === "true") as boolean,
    setMetadataSelector: (metadataSelector: boolean) =>
        set((state: any) => {
            setLocalItem('metadataSelector', metadataSelector)
            state.metadataSelector = metadataSelector;
        }),
    showProductCategories: (getLocalItem('showProductCategories', ConfigState.showProductCategories) === "true") as boolean,
    setShowProductCategories: (showProductCategories: boolean) =>
        set((state: any) => {
            setLocalItem('showProductCategories', showProductCategories)
            state.showProductCategories = showProductCategories;
        }),
    showDistance: (getLocalItem('showDistance', ConfigState.showProductCategories) === "true") as boolean,
    setShowDistance: (showDistance: boolean) =>
        set((state: any) => {
            setLocalItem('showDistance', showDistance)
            state.showDistance = showDistance;
        }),
    showDeepSearchHint: (getLocalItem('showDeepSearchHint', ConfigState.showDeepSearchHint) === "true") as boolean,
    setShowDeepSearchHint: (showDeepSearchHint: boolean) =>
        set((state: any) => {
            setLocalItem('showDeepSearchHint', showDeepSearchHint)
            state.showDeepSearchHint = showDeepSearchHint;
        }),
    databaseNamespaces: getLocalItem('databaseNamespaces', ConfigState.databaseNamespaces, true) as IOptionType,
    setDatabaseNamespaces: (databaseNamespaces: IOptionType) =>
        set((state: any) => {
            setLocalItem('databaseNamespaces', JSON.stringify(databaseNamespaces))
            state.databaseNamespaces = databaseNamespaces;
        }),
    
});

const createConfigActions = (set: any, get: any) => ({
});